import React from "react";
import { Box } from "@mui/material";
import { ProfileNavigation } from "./ProfileNavigation";
import { LoggedInSidebar } from "../../../components/sidebars/logged-in-sidebar/logged-in-sidebar";

export const ProfilePageDesktopLayout = ({
  selectedArea,
  onNavigation,
  children,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        boxSizing: "border-box",
        position: "relative",
        pt: "70px", // Add top padding to account for fixed header
      }}
    >
      {/* Desktop Sidebar */}
      <Box
        sx={{
          width: 280,
          flexShrink: 0,
          borderRight: 1,
          borderColor: "divider",
          backgroundColor: "background.paper",
          overflow: "hidden",
        }}
      >
        <ProfileNavigation
          isMobile={false}
          selectedArea={selectedArea}
          onNavigation={onNavigation}
        />
      </Box>

      {/* Desktop Content */}
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            overflow: "auto",
            width: "100%",
            maxWidth: "100%",
            boxSizing: "border-box",
          }}
        >
          {children}
        </Box>
      </Box>

      <LoggedInSidebar />
    </Box>
  );
};
